const DataClassificationPolicy = () => {
  return (
    <div className="overflow-hidden">
      <section className="relative py-24 hero-gradient mesh-gradient">
        <div className="absolute top-20 right-10 w-72 h-72 bg-purple-400/20 rounded-full blur-3xl" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-4xl md:text-6xl font-bold font-['Outfit'] tracking-tighter mb-6">
              Data Classification Policy
            </h1>
            <p className="text-lg text-slate-600 leading-relaxed">
              Jnan Innovative IT Solutions classifies information into categories that protect its value and sensitivity.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-slate max-w-none">
            <p><strong>Effective Date:</strong> 4/19/2026</p>

            <h2>1. Public</h2>
            <p>
              Information intended for public disclosure, such as marketing material and public documentation.
            </p>
            <br />

            <h2>2. Internal</h2>
            <p>
              Operational and business information intended only for authorized employees.
            </p>
            <br />

            <h2>3. Confidential</h2>
            <p>
              Business-sensitive information including contracts, financial records, and customer business data.
            </p>
            <br />

            <h2>4. Personally Identifiable Information (PII)</h2>
            <p>
              Information that identifies an individual, including names, addresses, phone numbers, and email addresses.
            </p>
            <br />

            <h2>5. Restricted / Amazon Customer PII</h2>
            <p>
              Amazon customer PII and restricted SP-API data are classified as Restricted/PII and require the highest level of protection. This may include names, shipping addresses, phone numbers, email addresses, order details, tax invoice fields, gift-message content, IP addresses, device identifiers, or other data that can identify an Amazon customer.
            </p>
            <p>
              Restricted/PII data may be accessed only for approved purposes such as merchant-fulfilled shipping, tax invoicing, tax remittance, or legal/regulatory obligations. It must not be used for marketing, customer profiling, resale, unrelated analytics, review manipulation, or cross-seller aggregation.
            </p>
            <br />

            <p>
              Access to Confidential, PII, and Restricted/PII data is granted only to authorized personnel on a need-to-know basis using role-based access controls.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DataClassificationPolicy;
